import clsx from 'clsx'
import TimelineNode from 'components/packages/TimelineNode'
import React from 'react'

const DARK_GREEN = 'var(--dark-green)'
const SAGE = 'var(--sage, #A8CB8F)'

// steps: array of { label, state: 'done' | 'pending' }, or null/empty for no timeline.
const AcknowledgementTimeline = ({ steps }) => {
  if (!steps?.length) return null

  return (
    <ul
      className="dome-list-no-style"
      style={{
        marginBottom: 6,
        padding: '12px 0',
        borderTop: '1px solid var(--accent, #F0F0F0)',
        borderBottom: '1px solid var(--accent, #F0F0F0)',
      }}
    >
      {steps.map((step, idx) => {
        const next = steps[idx + 1]
        const textClass = idx === 0 ? 'dome-p2 dome-color-lite-grey' : 'dome-p2 dome-color-darkest-grey'
        const nodeColor = step?.state === 'pending' ? SAGE : DARK_GREEN
        const edgeColor = next && next.state === 'pending' ? SAGE : DARK_GREEN

        return (
          <TimelineNode
            key={idx}
            label={step.label}
            textClass={textClass}
            nodeColor={nodeColor}
            edgeColor={edgeColor}
            isLast={idx === steps.length - 1}
          />
        )
      })}
    </ul>
  )
}

export default AcknowledgementTimeline
